import { FaLongArrowAltRight } from "react-icons/fa";

const stores = [{
    location: "Tiruppur",
    name: "Phonekadai.com Mobile sales and services ",
    add: "1st St, Venkateshapuram, S.V.Colony, T.N.K Puram, Tiruppur, Tamil Nadu 641602",
    Timings: "9:30 AM - 9:30 PM",
    contact: "99944 21661",
    maplink: "https://maps.app.goo.gl/kpYZH77ZGRa4V9kZ6"

},
]
const OurStores = () => {
    return (
        <div id="ourStores" className='w-full max-w-6xl mx-auto group mb-4 mt-6 sm:mt-8 lg:mt-10 px-4 sm:px-6'>
            <h2 className='text-xl md:text-2xl font-bold text-start'>Our Exclusive Stores</h2>
            <div className='mt-10 bg-[#F7F7F7] p-6 flex items-center gap-4 overflow-x-auto ' style={{ scrollbarWidth: 'none' }}>
                {stores.map((store, index) => (
                    <div key={index} className='min-w-64 max-w-64 bg-white p-4 rounded-lg shadow-lg ' >
                        <button className='bg-[#0F0F0F] uppercase text-white p-1 px-2 text-sm md:text-base rounded-md'> {store.location}</button>
                        <h3 className='text-lg font-semibold md:font-bold  my-2 '>{store.name}</h3>
                        <p className='text-xs md:text-smline-clamp-2 text-[#707070]'>{store.add}</p>
                        <p className='text-xs md:text-smmt-2 text-[#707070]'>Timings: {store.Timings}</p>
                        <p className='text-xs md:text-sm text-[#707070]'>Contact: {store.contact}</p>
                        <a href={store.maplink} target="_blank" rel="noopener noreferrer" className='text-[#42C8B7] mt-2 font-semibold text-sm md:text-base flex items-center gap-2 justify-start'>View Map <FaLongArrowAltRight /></a>
                    </div>
                ))}
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3542.79513048295!2d77.33972637452136!3d11.119629552770578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9073abaf37067%3A0x471e78144375a81!2sphonekadai.com!5e1!3m2!1sen!2sin!4v1761557724626!5m2!1sen!2sin" className="rounded-lg" width="790" height="235" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    );
};

export default OurStores;
